import { render, staticRenderFns } from "./OnboardingContractView.vue?vue&type=template&id=2457a114&scoped=true"
import script from "./OnboardingContractView.vue?vue&type=script&lang=js"
export * from "./OnboardingContractView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2457a114",
  null
  
)

export default component.exports